import React from 'react'
import GameBoard from './GameBoard'

function App() {
	return (
		<div className='app-container'>
			<GameBoard/>
		</div>
	)
}

export default App